import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';

export interface Specialty {
  id: number;
  name: string;
}

export const useSpecialtiesByPractice = (
  videaId: string,
  options?: UseQueryOptions<Specialty[]>,
) => {
  const { primaryOrganizationId: orgId } = useSelector(
    (state: any) => state.login.user,
  );

  return useQuery<Specialty[]>(
    ['specialties', 'practice', videaId],
    () =>
      makeAPIRequestReactQuery<Specialty[]>(
        `/referrals/practices/${videaId}/specialties`,
        undefined,
        'get',
        {
          headers: {
            Org: orgId,
          },
        },
      ),
    {
      enabled: !!videaId && !!orgId && videaId !== '',
      retry: 1,
      staleTime: Infinity,
      cacheTime: 24 * 60 * 60 * 1000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      ...options,
    },
  );
};
